import React, { useContext } from 'react'
import { Api } from '../contexts/Api';
import { Link } from 'react-router-dom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { CloudDone, Euro, VerifiedUser } from '@mui/icons-material';

function ProductsStatistic() {
    const { productsCount, ordersCount, inStockProducts, ordersRevenue } = useContext(Api);
    return (
        <div className="row">
            <div className="col-xl-3">
                <div className="card custom-card main-card-item primary">
                    <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between mb-3 flex-wrap">
                            <div>
                                <span className="d-block mb-3 fw-medium">Total Products</span>
                                <h3 className="fw-semibold lh-1 mb-0">{productsCount || 0}</h3>
                            </div>
                            <div className="text-end">
                                <div className="mb-4">
                                    <span className="avatar avatar-md bg-primary svg-white avatar-rounded">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width={256} height={256} fill="none" /><rect x={32} y={48} width={192} height={160} rx={8} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /><path d="M168,88a40,40,0,0,1-80,0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={16} /></svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3">
                <div className="card custom-card main-card-item">
                    <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between mb-3 flex-wrap">
                            <div>
                                <span className="d-block mb-3 fw-medium">Available products</span>
                                <h3 className="fw-semibold lh-1 mb-0">{inStockProducts}</h3>
                            </div>
                            <div className="text-end">
                                <div className="mb-4">
                                    <span className="avatar avatar-md bg-success svg-white avatar-rounded">
                                        <CloudDone />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3">
                <div className="card custom-card main-card-item">
                    <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between mb-3 flex-wrap">
                            <div>
                                <span className="d-block mb-3 fw-medium">Total Orders</span>
                                <h3 className="fw-semibold lh-1 mb-0">{ordersCount || 0}</h3>
                            </div>
                            <div className="text-end">
                                <div className="mb-4">
                                    <span className="avatar avatar-md bg-info svg-white avatar-rounded">
                                        <AssignmentIcon />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                        </div>
                    </div>
                </div>
            </div>
            

            <div className="col-xl-3">
                <div className="card custom-card main-card-item">
                    <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between mb-3 flex-wrap">
                            <div>
                                <span className="d-block mb-3 fw-medium">Total Revenue</span>
                                <h3 className="fw-semibold lh-1 mb-0">€{ordersRevenue}</h3>
                            </div>
                            <div className="text-end">
                                <div className="mb-4">
                                    <span className="avatar avatar-md bg-secondary svg-white avatar-rounded">
                                        <Euro/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductsStatistic